import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetTotalLeads = async () => {
  /**
   * input: null
   * output: Clients Array
   * description: fetches all Clients
   */
  try {
    const ClientsCollection = await collection(db, "leads");
    const q = query(
      ClientsCollection,
      where("bid", "==", getLocalStorageItem("bid")),
      where("is_deleted", "==", false)
    );

    const ClientsSnapshot = await getDocs(q);
    let Clients = [];
    ClientsSnapshot.forEach((e) => Clients.push({ ...e.data(), id: e.id }));
    return Clients;
  } catch (error) {
    console.log(error);
  }
};

export default GetTotalLeads;
